import { selectorFamily, SerializableParam, useRecoilValue } from 'recoil';
import { InvoiceService } from 'services';
import { isAuthenticated, refreshState, useSetRefreshState } from 'state';
import { InvoiceSummary } from 'types';

type InvoiceParams = {
    accountId: string,
    vendorId: string,
    invoiceId: string,
    voucherId?: string,
    adjustmentIdentityKey?: string,
} & SerializableParam;

export const invoice = selectorFamily<InvoiceSummary | null , InvoiceParams>({
    key: 'invoice',
    get: ({ accountId, vendorId, invoiceId, voucherId, adjustmentIdentityKey }) =>
        async ({ get }) => {
            get(refreshState(invoice({ accountId, vendorId, invoiceId, voucherId, adjustmentIdentityKey }).key));
            if (get(isAuthenticated) && accountId && vendorId && invoiceId) {
                const service = new InvoiceService();
                return await service.getInvoiceDetail(accountId, vendorId, invoiceId, voucherId, adjustmentIdentityKey);
            }
            
            return null;
    }
})

export const useInvoice = (accountId: string, vendorId: string, invoiceId: string, voucherId?: string, adjustmentIdentityKey?: string) => useRecoilValue(invoice({ accountId, vendorId, invoiceId, voucherId, adjustmentIdentityKey }));

export const useRefreshInvoice = (accountId: string, vendorId: string, invoiceId: string, voucherId?: string, adjustmentIdentityKey?: string) => useSetRefreshState(invoice({ accountId, vendorId, invoiceId, voucherId, adjustmentIdentityKey }));
